<template>
  <div class="lg:col-span-5 xl:col-span-6">
    <div class="header-text max-w-md xxl:max-w-lg text-center lg:text-left my-8">
      <h1
        id="header-h1"
        class="mt-4 lg:mt-0 text-primary-black text-3xl sm:text-4xl md:text-4xxl xxl:text-5xl leading-tight tracking-tight font-extrabold"
      >
        Modernne koduleht
        <span class="text-green-300">järelmaksuga</span>
      </h1>
      <p
        id="header-p"
        class="text-primary-gray mt-4 lg:mt-6 text-base md:text-lg xxl:text-xl font-light leading-relaxed tracking-wide"
      >Silmapaistev koduleht aitab suurendada klientide arvu ja müüki.</p>
      <button
        style="visibility: hidden"
        id="header-btn"
        class="mt-4 lg:mt-6 shadow-green px-10 py-3 border border-transparent text-sm uppercase tracking-wider leading-normal font-bold rounded-md text-white bg-green-300 hover:bg-indigo-400 focus:outline-none border-none focus:shadow-outline-indigo active:bg-indigo-400"
        @click="scrollTo('calculator-container')"
      >Avasta rohkem</button>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";

export default {
  name: "PageHeaderTitle",
  methods: {
    scrollTo(containerRef) {
      this.$emit("scrollTo", containerRef);
    },
    animationsInit() {
      const tl = gsap.timeline({
        defaults: { opacity: 0, ease: "slow" },
      });
      tl.from(".header-wrapper", { autoAlpha: 0 });
      tl.from("#header-h1", { y: -100, duration: 1.2 });
      tl.from("#header-p", { y: -75, duration: 1.2 }, "-=1");
      tl.from("#header-btn", { y: -40, duration: 1.2, autoAlpha: 0 }, "-=0.8");
    },
  },
  mounted() {
    this.animationsInit();
  },
};
</script>

<style scoped>
@media (max-width: 1023.99px) {
  .header-text {
    margin: 0 auto;
  }
}

@media (min-width: 1024px) {
  .header-text {
    margin-right: auto;
  }
}
</style>
